import { Alert } from '../types'

// just things needed for these alerts
export interface Customer {
  state: string
  planAddOnCode: string
  hasBpsPreference: boolean
  activeKeywordsCount: number
  assignedKeywordsCount: number
  activeRequestsCount: number
  proposedKeywordsCount: number
  keywordsWithBpsNeedsExist: boolean
}

export interface User {
  canCreateKeyword: boolean
  canUpdateBpsPreference: boolean
}

const defaultUser: User = {
  canCreateKeyword: true,
  canUpdateBpsPreference: true
}

function topAlert(customer: Customer, user: User = defaultUser): Alert {
  return alerts(customer, user)[0]
}

// in order of priority
function alerts(customer: Customer, user: User): Alert[] {
  return [
    user.canCreateKeyword && newProposedKeywordsAlert(customer),
    user.canCreateKeyword && noTopicsAlert(customer),
    user.canUpdateBpsPreference && bpsPreferencesAlert(customer)
  ].filter((a) => !!a)
}

function noTopicsAlert(customer: Customer): Alert {
  if ( (customer.activeKeywordsCount + customer.assignedKeywordsCount + customer.activeRequestsCount) === 0 && customer.state !== 'pending') {
    return {
      area: 'topics',
      level: 'problem',
      class: 'fas fa-exclamation-circle text-danger',
      tooltip: 'Please create a request to start receiving great content.',
      render: '<span></span>'
    }
  }
}

function bpsPreferencesAlert(customer: Customer): Alert {
  const isBps = customer.planAddOnCode && (['option-a', 'option-b', 'option-c'].includes(customer.planAddOnCode))
                || customer.keywordsWithBpsNeedsExist
  if (isBps && !customer.hasBpsPreference) {
    return {
      area: 'bps',
      level: 'problem',
      class: 'fas fa-exclamation-circle text-danger',
      render: '<span></span>'
    }
  }
}

function newProposedKeywordsAlert(customer: Customer): Alert {
  if (customer.proposedKeywordsCount > 0) {
    return {
      area: 'topics',
      level: 'info',
      class: 'alert-sm fa-stack',
      tooltip: 'You have Topic Ideas ready for review',
      render: `
        <div class="fas fa-stack-2x fa-circle text-tertiary"></div>
        <strong class="fa-stack-1x fa-stack-text text-white">${customer.proposedKeywordsCount}</strong>
      `
    }
  }
}

export {
  topAlert,
  alerts,
  noTopicsAlert,
  bpsPreferencesAlert,
  newProposedKeywordsAlert,
}
